import { Injectable } from "@angular/core";
import { Observable, Subscription, Subject, timer } from "rxjs";
import { Router, ActivatedRoute } from "@angular/router";
// import { Observable, Subject, Subscription, BehaviorSubject} from 'rxjs/Rx';

@Injectable({
  providedIn: "root",
})
export class IdleTimeoutService {
  private _count: number = 0;
  private _timeoutSeconds: number = 15;
  private timerSubscription: Subscription;
  private timer: Observable<number>;
  private resetOnTrigger: boolean = false;
  public timeoutExpired: Subject<number> = new Subject<number>();

  constructor(private router: Router) {
    if (this.router.url !== "/login") {
      // console.log("Constructed " + this._serviceId, new Date().toLocaleTimeString());

      this.timeoutExpired.subscribe((n) => {
        // console.log("timeoutExpired subject next.. " + n.toString(), new Date().toLocaleTimeString())
      });

      this.startTimer();
    }
  }

  public startTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timer = timer(this._timeoutSeconds * 1000);
    this.timerSubscription = this.timer.subscribe((n) => {
      this.timerComplete(n);
    });
  }

  public stopTimer() {
    this.timerSubscription.unsubscribe();
  }

  public resetTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timer = timer(this._timeoutSeconds * 1000);
    this.timerSubscription = this.timer.subscribe((n) => {
      this.timerComplete(n);
    });
  }

  private timerComplete(n: number) {
    this.timeoutExpired.next(++this._count);

    if (this.resetOnTrigger) {
      this.startTimer();
    }
  }
}
